/* eslint-disable react/jsx-indent-props */
import React, { useEffect, useState } from "react";
import { observer } from "mobx-react-lite";
import { useStores } from "../use.store";
import { informationID } from "../utils/constants";

const ContactDetailComponent = observer(() => {
  const { generalStore } = useStores();
  const [filteredData, setFilteredData] = useState([]);

  useEffect(() => {
    const filter = generalStore.information.filter(
      (item) => item.categoryId === informationID.contactDetail
    );

    setFilteredData(filter);
  }, []);

  const openTel = (value) => {
    window.open(`tel:${value}`, "_self");
  };

  const openEmail = (value) => {
    window.open(`mailto:${value}`, "_self");
  };

  return (
    <div className="w-full flex flex-col gap-4">
      {filteredData.map((data) => {
        return (
          <div
            className="flex flex-row gap-4 bg-white p-4 rounded-md items-center"
            onClick={() => {
              data.name.toLowerCase() !== "e-mail" && openTel(data.description);
            }}
          >
            <img
              src={require(`../assets/images/${
                data.name.toLowerCase() === "e-mail" ? "email" : "call"
              }.svg`)}
              className="w-6 h-6 md:w-10 md:h-10"
            />
            {data.name.toLowerCase() !== "e-mail" && (
              <p>
                <span className="text-xs md:text-sm text-[#959595]">
                  {data.name}
                </span>
                <br />
                <span className="text-base md:text-2xl font-bold">
                  {data.description}
                </span>
              </p>
            )}
            {data.name.toLowerCase() === "e-mail" && (
              <p>
                <span className="text-xs md:text-sm text-[#959595]">
                  {data.name}
                </span>
                <br />
                <a className="text-base md:text-2xl font-bold">
                  {data.description}
                </a>
              </p>
            )}
          </div>
        );
      })}
    </div>
  );
});

export default ContactDetailComponent;
